// extracted by mini-css-extract-plugin
export default {"payButton":"styles_payButton__M8vhw"};